import { render, staticRenderFns } from "./FoodsLibrary.vue?vue&type=template&id=1acd20c7&scoped=true&"
import script from "./FoodsLibrary.vue?vue&type=script&lang=js&"
export * from "./FoodsLibrary.vue?vue&type=script&lang=js&"
import style0 from "./FoodsLibrary.vue?vue&type=style&index=0&id=1acd20c7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acd20c7",
  null
  
)

export default component.exports